module.exports = {"uk":{"timezones":["Europe/London"]},"ie":{"timezones":["Europe/Dublin"]},"es":{"timezones":["Europe/Madrid"]},"it":{"timezones":["Europe/Rome"]},"at":{"timezones":["Europe/Vienna"]},"be":{"timezones":["Europe/Brussels"]},"bg":{"timezones":["Europe/Sofia"]},"ch":{"timezones":["Europe/Zurich"]},"de":{"timezones":["Europe/Berlin"]},"dk":{"timezones":["Europe/Copenhagen"]},"lu":{"timezones":["Europe/Luxembourg City"]},"nl":{"timezones":["Europe/Amsterdam"]},"pl":{"timezones":["Europe/Warsaw"]},"sk":{"timezones":["Europe/Bratislava"]}}


//////////////////
// WEBPACK FOOTER
// ./src/actions/timezones.json
// module id = 709
// module chunks = 0